export default "__VITE_ASSET__BwxHv893__"